import React from 'react'
import styles from './DealCountdown.module.css'
import SaleCountdown from './SaleCountdown'

// "Deal ends in" strip for a running limited deal: black bar, white label with
// a pulsing VRS red dot, red Days / Hrs / Mins / Secs boxes. One look for the
// shop cards and the deal popup. The clock is the caller's (`nowMs`,
// `mounted`); `live` lets the digits tick on their own (see SaleCountdown).
function DealCountdown({ label = 'Deal ends in', targetMs, nowMs, mounted = true, live = false, className }) {
  return (
    <div className={[styles.strip, className].filter(Boolean).join(' ')}>
      <span className={styles.label}>
        <span className={styles.dot} aria-hidden="true"/>
        {label}
      </span>
      <SaleCountdown targetMs={targetMs} nowMs={nowMs} mounted={mounted} live={live} size="sm" theme="red"/>
    </div>
  )
}

export default DealCountdown
